/**
 * The Authentication Requests screen — OND-212.
 *
 * The estate's own queue of authorship requests, pulled out of the general
 * inbox, with OND-60's service beside it and the works this estate has put
 * its name to beneath. Every rule the screen follows is one the inbox and the
 * catalogue already follow; this copy only says which part of them a reader
 * is looking at.
 *
 * TWO SENTENCES ARE LOAD-BEARING and are the owner's own words: silence is
 * neither an acceptance nor a rejection, and assignment grants nothing. Both
 * are said on the screen rather than only in the ticket.
 */
export const AUTHENTICATIONS_COPY = {
  loading: "Loading authentication requests…",

  lead:
    "Somebody has recorded that a work is by this artist and asked this estate to say so. " +
    "Confirming issues the work its catalogue number; disputing records that this estate " +
    "does not stand behind the claim. An unanswered request is neither.",

  awaitingTitle: "Awaiting your answer",
  awaitingEmpty: "Nothing is waiting on this estate.",
  awaitingEmptyDetail:
    "A request appears here when a collector, gallery or agent asks this estate to confirm " +
    "that a work is by its artist. Naming the artist on a work asks nothing.",

  answeredTitle: "Answered",
  answeredDetail: "What this estate has already said, newest first.",

  serviceTitle: "Targets, reviewers and fees",
  serviceLead:
    "Each request is a paid service with a target date. From here a case can be handed to a " +
    "named colleague, sent back for more evidence, or given a revised target. Assigning a " +
    "case does not let the reviewer answer it: that still needs the standing the studio gave " +
    "them, and signing still needs live authority for the artist.",
  serviceEmpty: "No cases yet.",

  confirmedTitle: "Confirmed by this estate",
  confirmedLead:
    "The works this estate has put its name to, each with the catalogue number its " +
    "confirmation issued. This is the list the catalogue raisonné is made of.",
  confirmedEmpty: "This estate has not yet confirmed any work.",
  confirmedEmptyDetail:
    "A work joins this list when this estate confirms an authorship claim, and at no other " +
    "moment — not when it is registered, and not when its artist is named.",
  catalogueLink: "Open the catalogue →",

  /** Beneath an awaiting request: what the service side says about it. */
  stripTarget: "Target",
  stripOverdue: "Overdue",
  stripWith: "With",
  stripUnassigned: "Not yet assigned",
  stripEvidence: "More evidence asked for",
} as const;
